/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AbortSessionRequest} from "../model/abort-session-request";
import {AddParticipantToSessionRequest} from "../model/add-participant-to-session-request";
import {AddRunScheduleEntryToAutomaticRecordingSessionRequest} from "../model/add-run-schedule-entry-to-automatic-recording-session-request";
import {AddRunToTeamTrainingSessionRequest} from "../model/add-run-to-team-training-session-request";
import {AddStationToAutomaticRecordingSessionRequest} from "../model/add-station-to-automatic-recording-session-request";
import {AddStationToExamSessionRequest} from "../model/add-station-to-exam-session-request";
import {AddStationToMultiRoomRecordingSessionRequest} from "../model/add-station-to-multi-room-recording-session-request";
import {AddStationToPeerPracticeSessionRequest} from "../model/add-station-to-peer-practice-session-request";
import {AutomaticRecordingSession} from "../model/automatic-recording-session";
import {CorrectAnExamParticipantAfterSessionFinishedRequest} from "../model/correct-an-exam-participant-after-session-finished-request";
import {CountTagResponse} from "../model/count-tag-response";
import {DeleteSessionRequest} from "../model/delete-session-request";
import {ExamScheduleEntry} from "../model/exam-schedule-entry";
import {ExamSession} from "../model/exam-session";
import {ExamSessionRemoteExaminationDto} from "../model/exam-session-remote-examination-dto";
import {ExamSessionRunTimes} from "../model/exam-session-run-times";
import {ExternalAvailabilityResponse} from "../model/external-availability-response";
import {ISimSession} from "../model/i-sim-session";
import {MultiRoomRecordingSession} from "../model/multi-room-recording-session";
import {NonSimulationSession} from "../model/non-simulation-session";
import {Participant} from "../model/participant";
import {PeerPracticeSession} from "../model/peer-practice-session";
import {RemoveParticipantFromSessionRequest} from "../model/remove-participant-from-session-request";
import {RemoveRunFromTeamTrainingSessionRequest} from "../model/remove-run-from-team-training-session-request";
import {RemoveRunScheduleEntryFromAutomaticRecordingSessionRequest} from "../model/remove-run-schedule-entry-from-automatic-recording-session-request";
import {RemoveStationFromAutomaticRecordingSessionRequest} from "../model/remove-station-from-automatic-recording-session-request";
import {RemoveStationFromExamSessionRequest} from "../model/remove-station-from-exam-session-request";
import {RemoveStationFromMultiRoomRecordingSessionRequest} from "../model/remove-station-from-multi-room-recording-session-request";
import {RemoveStationFromPeerPracticeSessionRequest} from "../model/remove-station-from-peer-practice-session-request";
import {StartExamSessionRequest} from "../model/start-exam-session-request";
import {SwitchStudentBetweenStationsInRunRequest} from "../model/switch-student-between-stations-in-run-request";
import {TeamTrainingSession} from "../model/team-training-session";
import {UpdateDurationOfScheduleEntryInAutomaticRecordingSessionRequest} from "../model/update-duration-of-schedule-entry-in-automatic-recording-session-request";
import {UpdateIntermissionInPeerPracticeSessionRequest} from "../model/update-intermission-in-peer-practice-session-request";
import {UpdateParticipantStateInSessionRequest} from "../model/update-participant-state-in-session-request";
import {UpdateRunInTeamTrainingSessionRequest} from "../model/update-run-in-team-training-session-request";
import {UpdateStationInAutomaticRecordingSessionRequest} from "../model/update-station-in-automatic-recording-session-request";
import {UpdateStationInExamSessionRequest} from "../model/update-station-in-exam-session-request";
import {UpdateStationInMultiRoomRecordingSessionRequest} from "../model/update-station-in-multi-room-recording-session-request";
import {UpdateStationInPeerPracticeSessionRequest} from "../model/update-station-in-peer-practice-session-request";
import {UpsertAutomaticRecordingSessionMetaDataRequest} from "../model/upsert-automatic-recording-session-meta-data-request";
import {UpsertExamSessionMetaDataRequest} from "../model/upsert-exam-session-meta-data-request";
import {UpsertMultiRoomRecordingSessionMetaDataRequest} from "../model/upsert-multi-room-recording-session-meta-data-request";
import {UpsertNonSimulationSessionMetaDataRequest} from "../model/upsert-non-simulation-session-meta-data-request";
import {UpsertPeerPracticeSessionMetaDataRequest} from "../model/upsert-peer-practice-session-meta-data-request";
import {UpsertTeamTrainingSessionMetaDataRequest} from "../model/upsert-team-training-session-meta-data-request";

@Injectable({
    providedIn: "root",
})
export class SimSessionService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Called whenever an exam session is aborted / canceled
 */ 

    public abortSession(request: AbortSessionRequest) {
        return super.post<void>(`/api/Session/AbortSession`, request);
    }
/**
 * Called whenever a peer practice session is started
 */ 

    public addGroupToPeerPracticeSession(sessionId: string, groupId: string) {
        return super.post<PeerPracticeSession>(`/api/Session/AddGroupToPeerPracticeSession/add/${encodeURIComponent(sessionId)}/${encodeURIComponent(groupId)}`, {});
    }
/**
 * Adds a participant to a session.
 */ 

    public addParticipantToSession(addParticipantToSessionRequest: AddParticipantToSessionRequest) {
        return super.post<Participant[]>(`/api/Session/AddParticipantToSession`, addParticipantToSessionRequest);
    }
/**
 * Adds a run schedule entry to an existing automatic recording session.
 */ 

    public addRunScheduleEntryToAutomaticRecordingSession(request: AddRunScheduleEntryToAutomaticRecordingSessionRequest) {
        return super.post<AutomaticRecordingSession>(`/api/Session/AddRunScheduleEntryToAutomaticRecordingSession`, request);
    }
/**
 * Adds an empty scenario recording group to a training session.
 */ 

    public addRunToTeamTrainingSession(addRunToTeamTrainingSessionRequest: AddRunToTeamTrainingSessionRequest) {
        return super.post<TeamTrainingSession>(`/api/Session/AddRunToTeamTrainingSession`, addRunToTeamTrainingSessionRequest);
    }
/**
 * Adds a station to an existing automatic recording session.
 */ 

    public addStationToAutomaticRecordingSession(request: AddStationToAutomaticRecordingSessionRequest) {
        return super.post<AutomaticRecordingSession>(`/api/Session/AddStationToAutomaticRecordingSession`, request);
    }
/**
 * Adds a station to an existing exam session.
 */ 

    public addStationToExamSession(request: AddStationToExamSessionRequest) {
        return super.post<ExamSession>(`/api/Session/AddStationToExamSession`, request);
    }
/**
 * Adds a station to an existing multi-room recording session.
 */ 

    public addStationToMultiRoomRecordingSession(request: AddStationToMultiRoomRecordingSessionRequest) {
        return super.post<MultiRoomRecordingSession>(`/api/Session/AddStationToMultiRoomRecordingSession`, request);
    }
/**
 * Adds a station to an existing peer practice session.
 */ 

    public addStationToPeerPracticeSession(request: AddStationToPeerPracticeSessionRequest) {
        return super.post<PeerPracticeSession>(`/api/Session/AddStationToPeerPracticeSession`, request);
    }
/**
 * Correct an exam participant after the session has finished.
 */ 

    public correctAnExamParticipantAfterSessionFinished(request: CorrectAnExamParticipantAfterSessionFinishedRequest) {
        return super.post<void>(`/api/Session/CorrectAnExamParticipantAfterSessionFinished`, request);
    }
/**
 * Deletes a session using the provided deleteSessionRequest.
 */ 

    public deleteSession(deleteSessionRequest: DeleteSessionRequest) {
        return super.post<boolean>(`/api/Session/DeleteSession`, deleteSessionRequest);
    }
/**
 * Called whenever a multi-room recording session should be stopped
 */ 

    public finishMultiRoomRecordingSession(sessionId: string) {
        return super.post<MultiRoomRecordingSession>(`/api/Session/FinishMultiRoomRecordingSession/mmr/${encodeURIComponent(sessionId)}/stop`, {});
    }
/**
 * Checks if the session's external resources are available in the given time range.
 */ 

    public getExternalAvailability(sessionId: string, from: Date | string, to: Date | string) {
        return super.get<ExternalAvailabilityResponse>(`/api/Session/GetExternalAvailability`, {sessionId: sessionId, from: from, to: to});
    }
/**
 * Get the run times for an exam session
 */ 

    public getRunTimes(examSessionId: string) {
        return super.get<ExamSessionRunTimes>(`/api/Session/GetRunTimes`, {examSessionId: examSessionId});
    }
/**
 * Retrieves a session by its unique id.
 */ 

    public getSessionById(sessionId: string) {
        return super.get<ISimSession>(`/api/Session/GetSessionById`, {sessionId: sessionId});
    }
/**
 * Get all exam sessions that are ready for remote examination
 */ 

    public getSessionsForRemoteExamination() {
        return super.get<ExamSessionRemoteExaminationDto[]>(`/api/Session/GetSessionsForRemoteExamination`, );
    }
/**
 * Get a list of sessions that have occupied rooms
 */ 

    public getSessionsWithOccupiedRooms(sessionId: string) {
        return super.get<ISimSession[]>(`/api/Session/GetSessionsWithOccupiedRooms/${encodeURIComponent(sessionId)}/occupiedRooms`, );
    }
/**
 * Get tag count of scenarios used in sessions
 */ 

    public getTagsCountOfScenariosUsedInSessions(startDate: Date | string, endDate: Date | string) {
        return super.get<CountTagResponse[]>(`/api/Session/GetTagsCountOfScenariosUsedInSessions`, {startDate: startDate, endDate: endDate});
    }
/**
 * Called whenever a peer practice session is started
 */ 

    public removeGroupFromPeerPracticeSession(sessionId: string, groupId: string) {
        return super.post<PeerPracticeSession>(`/api/Session/RemoveGroupFromPeerPracticeSession/remove/${encodeURIComponent(sessionId)}/${encodeURIComponent(groupId)}`, {});
    }
/**
 * Removes a participant from a session.
 */ 

    public removeParticipantFromSession(removeParticipantFromSessionRequest: RemoveParticipantFromSessionRequest) {
        return super.post<Participant[]>(`/api/Session/RemoveParticipantFromSession`, removeParticipantFromSessionRequest);
    }
/**
 * Removes a run from a team training session.
 */ 

    public removeRunFromTeamTrainingSession(removeRunFromTeamTrainingSessionRequest: RemoveRunFromTeamTrainingSessionRequest) {
        return super.post<TeamTrainingSession>(`/api/Session/RemoveRunFromTeamTrainingSession`, removeRunFromTeamTrainingSessionRequest);
    }
/**
 * Removes a run schedule entry from an existing automatic recording session. Also removes the break right after the run schedule entry if it exists or the break before the run schedule entry if it is the last entry.
 */ 

    public removeRunScheduleEntryFromAutomaticRecordingSession(request: RemoveRunScheduleEntryFromAutomaticRecordingSessionRequest) {
        return super.post<AutomaticRecordingSession>(`/api/Session/RemoveRunScheduleEntryFromAutomaticRecordingSession`, request);
    }
/**
 * Removes a station from an existing automatic recording session.
 */ 

    public removeStationFromAutomaticRecordingSession(request: RemoveStationFromAutomaticRecordingSessionRequest) {
        return super.post<AutomaticRecordingSession>(`/api/Session/RemoveStationFromAutomaticRecordingSession`, request);
    }
/**
 * Removes a station from an existing exam session.
 */ 

    public removeStationFromExamSession(request: RemoveStationFromExamSessionRequest) {
        return super.post<ExamSession>(`/api/Session/RemoveStationFromExamSession`, request);
    }
/**
 * Removes a station from an existing multi-room recording session.
 */ 

    public removeStationFromMultiRoomRecordingSession(request: RemoveStationFromMultiRoomRecordingSessionRequest) {
        return super.post<MultiRoomRecordingSession>(`/api/Session/RemoveStationFromMultiRoomRecordingSession`, request);
    }
/**
 * Removes a station from an existing peer practice session.
 */ 

    public removeStationFromPeerPracticeSession(request: RemoveStationFromPeerPracticeSessionRequest) {
        return super.post<PeerPracticeSession>(`/api/Session/RemoveStationFromPeerPracticeSession`, request);
    }
/**
 * Called whenever an exam session is started
 */ 

    public startExamSession(request: StartExamSessionRequest) {
        return super.post<boolean>(`/api/Session/StartExamSession`, request);
    }
/**
 * Called whenever a multi-room recording session is started
 */ 

    public startMultiRoomRecordingSession(sessionId: string) {
        return super.post<MultiRoomRecordingSession>(`/api/Session/StartMultiRoomRecordingSession/mmr/${encodeURIComponent(sessionId)}/start`, {});
    }
/**
 * Called whenever a peer practice session is started
 */ 

    public startPeerPracticeSession(sessionId: string) {
        return super.post<boolean>(`/api/Session/StartPeerPracticeSession/${encodeURIComponent(sessionId)}/start`, {});
    }
/**
 * Correct an exam participant after the session has finished.
 */ 

    public switchStudentBetweenStationsInRun(request: SwitchStudentBetweenStationsInRunRequest) {
        return super.post<ExamScheduleEntry[]>(`/api/Session/SwitchStudentBetweenStationsInRun`, request);
    }
/**
 * Update the duration of a schedule entry in an existing automatic recording session.
 */ 

    public updateDurationOfScheduleEntryInAutomaticRecordingSession(request: UpdateDurationOfScheduleEntryInAutomaticRecordingSessionRequest) {
        return super.post<AutomaticRecordingSession>(`/api/Session/UpdateDurationOfScheduleEntryInAutomaticRecordingSession`, request);
    }
/**
 * Update Intermission in Peer Practice Session
 */ 

    public updateIntermissionInPeerPracticeSession(sessionId: string, scheduleEntryId: string, request: UpdateIntermissionInPeerPracticeSessionRequest) {
        return super.post<PeerPracticeSession>(`/api/Session/UpdateIntermissionInPeerPracticeSession/updateIntermission/${encodeURIComponent(sessionId)}/${encodeURIComponent(scheduleEntryId)}`, request);
    }
/**
 * Updates the language of an exam session.
 */ 

    public updateLanguageOfExamSession(examSessionId: string, language: string) {
        return super.post<ExamSession>(`/api/Session/UpdateLanguageOfExamSession/${encodeURIComponent(examSessionId)}/language/${encodeURIComponent(language)}`, {});
    }
/**
 * Updates the state of a participant in a session.
 */ 

    public updateParticipantStateInSession(updateParticipantStateInSessionRequest: UpdateParticipantStateInSessionRequest) {
        return super.post<Participant[]>(`/api/Session/UpdateParticipantStateInSession`, updateParticipantStateInSessionRequest);
    }
/**
 * Updates a run in a team training session.
 */ 

    public updateRunInTeamTrainingSession(updateRunInTeamTrainingSessionRequest: UpdateRunInTeamTrainingSessionRequest) {
        return super.post<TeamTrainingSession>(`/api/Session/UpdateRunInTeamTrainingSession`, updateRunInTeamTrainingSessionRequest);
    }
/**
 * Updates a station in an existing automatic recording session.
 */ 

    public updateStationInAutomaticRecordingSession(request: UpdateStationInAutomaticRecordingSessionRequest) {
        return super.post<AutomaticRecordingSession>(`/api/Session/UpdateStationInAutomaticRecordingSession`, request);
    }
/**
 * Updates a station in an existing exam session.
 */ 

    public updateStationInExamSession(request: UpdateStationInExamSessionRequest) {
        return super.post<ExamSession>(`/api/Session/UpdateStationInExamSession`, request);
    }
/**
 * Updates a station in an existing multi-room recording session.
 */ 

    public updateStationInMultiRoomRecordingSession(request: UpdateStationInMultiRoomRecordingSessionRequest) {
        return super.post<MultiRoomRecordingSession>(`/api/Session/UpdateStationInMultiRoomRecordingSession`, request);
    }
/**
 * Updates a station in an existing peer practice session.
 */ 

    public updateStationInPeerPracticeSession(request: UpdateStationInPeerPracticeSessionRequest) {
        return super.post<PeerPracticeSession>(`/api/Session/UpdateStationInPeerPracticeSession`, request);
    }
/**
 * Updates an existing or add a new automatic recording session to an event.
 */ 

    public upsertAutomaticRecordingSessionMetaData(request: UpsertAutomaticRecordingSessionMetaDataRequest) {
        return super.post<AutomaticRecordingSession>(`/api/Session/UpsertAutomaticRecordingSessionMetaData`, request);
    }
/**
 * Upserts metadata for an exam session.
 */ 

    public upsertExamSessionMetaData(request: UpsertExamSessionMetaDataRequest) {
        return super.post<ExamSession>(`/api/Session/UpsertExamSessionMetaData`, request);
    }
/**
 * Updates an existing or inserts a new multi-room recording session.
 */ 

    public upsertMultiRoomRecordingSessionMetaData(request: UpsertMultiRoomRecordingSessionMetaDataRequest) {
        return super.post<MultiRoomRecordingSession>(`/api/Session/UpsertMultiRoomRecordingSessionMetaData`, request);
    }
/**
 * Upserts metadata for a non-simulation session.
 */ 

    public upsertNonSimulationSessionMetaData(request: UpsertNonSimulationSessionMetaDataRequest) {
        return super.post<NonSimulationSession>(`/api/Session/UpsertNonSimulationSessionMetaData`, request);
    }
/**
 * Upserts metadata for a peer practice session.
 */ 

    public upsertPeerPracticeSessionMetaData(request: UpsertPeerPracticeSessionMetaDataRequest) {
        return super.post<PeerPracticeSession>(`/api/Session/UpsertPeerPracticeSessionMetaData`, request);
    }
/**
 * Upserts metadata for a team training session.
 */ 

    public upsertTeamTrainingSessionMetaData(request: UpsertTeamTrainingSessionMetaDataRequest) {
        return super.post<TeamTrainingSession>(`/api/Session/UpsertTeamTrainingSessionMetaData`, request);
    }
}